// extracted by mini-css-extract-plugin
module.exports = {"root":"Prose_root__LgwRG","small":"Prose_small__BCSe6"};